( function () {
	'use strict';

	function qs( sel, ctx )  { return ( ctx || document ).querySelector( sel ); }
	function qsa( sel, ctx ) { return Array.from( ( ctx || document ).querySelectorAll( sel ) ); }

	// ── Volunteer page: wire Sub Hero "Become a Volunteer" button to scroll to form ──
	var formTarget = document.getElementById( 'volunteer-form' );
	if ( formTarget ) {
		qsa( '.sub-hero-block a, .sub-hero-block button' ).forEach( function ( btn ) {
			var href = ( btn.getAttribute( 'href' ) || '' ).trim();
			if ( btn.tagName === 'BUTTON' || href === '#' || href === '' ) {
				btn.addEventListener( 'click', function ( e ) {
					e.preventDefault();
					formTarget.scrollIntoView( { behavior: 'smooth', block: 'start' } );
				} );
			}
		} );
	}

	qsa( '.vfb-section' ).forEach( function ( section ) {

		var redirectUrl      = section.dataset.redirect || '';
		var cardsGrid        = qs( '#vfb-cards-grid',       section );
		var workFromGrid     = qs( '#vfb-workfrom-grid',    section );
		var workFromErrEl    = qs( '#vfb-workfrom-error',   section );
		var otherField       = qs( '#vfb-other-field',      section );
		var otherInput       = qs( '#vfb-other-input',      section );
		var submitBtn        = qs( '#vfb-submit-btn',       section );
		var cf7Wrap          = qs( '.wpcf7',                section );
		var startDateInput   = qs( '#vfb-start-date',       section );
		var endDateInput     = qs( '#vfb-end-date',         section );

		if ( ! cardsGrid ) { return; }

		/* ── State ───────────────────────────────────────────────────────── */
		var selectedIds = [];   // multi-select interest cards
		var selectedWorkFrom = '';  // single-select work-from card value

		/* ── Work From cards: click handler (single-select) ─────────────── */
		if ( workFromGrid ) {
			qsa( '.vfb-workfrom-card', workFromGrid ).forEach( function ( card ) {
				card.addEventListener( 'click', function () {
					var val = card.dataset.value || '';
					qsa( '.vfb-workfrom-card', workFromGrid ).forEach( function ( c ) {
						c.classList.remove( 'vfb-workfrom-active' );
						c.setAttribute( 'aria-checked', 'false' );
					} );
					card.classList.add( 'vfb-workfrom-active' );
					card.setAttribute( 'aria-checked', 'true' );
					selectedWorkFrom = val;
					showWorkFromError( '' );
					syncWorkFrom();
				} );
				card.addEventListener( 'keydown', function ( e ) {
					if ( e.key === 'Enter' || e.key === ' ' ) { e.preventDefault(); card.click(); }
				} );
			} );
		}

		/* ── Helpers for Work From error display ─────────────────────────── */
		function showWorkFromError( msg ) {
			if ( ! workFromErrEl ) { return; }
			if ( msg ) {
				workFromErrEl.textContent = msg;
				workFromErrEl.style.display = 'block';
			} else {
				workFromErrEl.textContent = '';
				workFromErrEl.style.display = 'none';
			}
		}

		/* ── Sync work-from card value to CF7 hidden field ───────────────── */
		function syncWorkFrom() {
			var hidden = cf7Wrap ? qs( 'input[name="vfb-work-from"]', cf7Wrap ) : null;
			if ( hidden ) {
				hidden.value = selectedWorkFrom;
			}
		}

		/* ── Sync "Other" description field ──────────────────────────────── */
		function syncOtherField() {
			if ( ! otherField ) { return; }
			if ( selectedIds.indexOf( 'other' ) !== -1 ) {
				otherField.style.display = '';
			} else {
				otherField.style.display = 'none';
				if ( otherInput ) { otherInput.value = ''; }
			}
		}

		/* ── Populate ALL CF7 hidden fields ──────────────────────────────── */
		function updateCF7Fields() {
			// Interests — store display labels (read from card DOM), not raw slugs
			var interestsField = qs( '.wpcf7-form input[name="vfb-interests"]', section );
			if ( interestsField ) {
				var labels = selectedIds.map( function ( id ) {
					if ( id === 'other' ) { return 'Other'; }
					var card    = qs( '.vfb-card[data-id="' + id + '"]', cardsGrid );
					var labelEl = card ? card.querySelector( '.vfb-card-label' ) : null;
					return labelEl ? labelEl.textContent.trim() : id;
				} );
				interestsField.value = labels.join( ', ' );
			}

			// Other description — use '-' when nothing is entered
			var otherDescField = qs( '.wpcf7-form input[name="vfb-other-desc"]', section );
			if ( otherDescField ) {
				otherDescField.value = ( otherInput && otherInput.value.trim() )
					? otherInput.value.trim()
					: '-';
			}

			// Work-from — sync dropdown selection to hidden CF7 field
			syncWorkFrom();
		}

		/* ── Interest Cards — multi-select ───────────────────────────────── */
		qsa( '.vfb-card', cardsGrid ).forEach( function ( card ) {
			var id = card.dataset.id || '';

			card.addEventListener( 'click', function () {
				var idx = selectedIds.indexOf( id );
				if ( idx === -1 ) {
					selectedIds.push( id );
					card.classList.add( 'vfb-card-active' );
					card.setAttribute( 'aria-checked', 'true' );
				} else {
					selectedIds.splice( idx, 1 );
					card.classList.remove( 'vfb-card-active' );
					card.setAttribute( 'aria-checked', 'false' );
				}
				syncOtherField();
				updateCF7Fields();
				// Clear interest error as soon as any card is selected
				if ( selectedIds.length > 0 ) {
					var iErr = qs( '.vfb-interests-error', section );
					if ( iErr ) iErr.textContent = '';
					cardsGrid.classList.remove( 'vfb-invalid' );
				}
			} );

			card.addEventListener( 'keydown', function ( e ) {
				if ( e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' ) { return; }
				if ( e.key === 'Enter' || e.key === ' ' ) { e.preventDefault(); card.click(); }
			} );
		} );

		/* ── Keep hidden fields in sync when "Other" text changes ───────── */
		if ( otherInput ) {
			otherInput.addEventListener( 'input', updateCF7Fields );
		}

		/* ── Sync date inputs → CF7 hidden fields ────────────────────────── */
		function syncDates() {
			if ( ! cf7Wrap ) { return; }
			var startField = qs( 'input[name="vfb-start-date"]', cf7Wrap );
			var endField   = qs( 'input[name="vfb-end-date"]',   cf7Wrap );
			if ( startField && startDateInput ) { startField.value = startDateInput.value; }
			if ( endField   && endDateInput   ) { endField.value   = endDateInput.value;   }
		}
		if ( startDateInput ) {
			startDateInput.addEventListener( 'change', function () {
				// Keep end-date min ≥ start-date
				if ( endDateInput && startDateInput.value ) {
					endDateInput.min = startDateInput.value;
					// Clear end date if it's now before the new start date
					if ( endDateInput.value && endDateInput.value < startDateInput.value ) {
						endDateInput.value = '';
					}
				}
				syncDates();
			} );
		}
		if ( endDateInput ) {
			endDateInput.addEventListener( 'change', function () {
				syncDates();
				setDateError( endDateInput, '' );
			} );
		}
		if ( startDateInput ) {
			startDateInput.addEventListener( 'change', function () {
				setDateError( startDateInput, '' );
			} );
		}

		/* ── Transform Gender text input → styled select dropdown ── */
		( function () {
			var genderOptions = [ 'Male', 'Female', 'Other' ];
			qsa( '.vfb-field', section ).forEach( function ( field ) {
				var label = qs( '.vfb-label', field );
				if ( ! label || ! /gender/i.test( label.textContent ) ) { return; }
				var wrap  = qs( '.wpcf7-form-control-wrap', field );
				var input = wrap ? qs( 'input[type="text"], input:not([type="hidden"])', wrap ) : null;
				if ( ! input ) { return; }

				var sel = document.createElement( 'select' );
				sel.name      = input.name;
				sel.className = input.className.replace( /wpcf7-text/g, 'wpcf7-select' );
				sel.style.cssText = window.getComputedStyle( input ).cssText;

				// Placeholder option
				var placeholder = document.createElement( 'option' );
				placeholder.value = '';
				placeholder.textContent = 'Select Gender';
				placeholder.disabled    = true;
				placeholder.selected    = true;
				sel.appendChild( placeholder );

				genderOptions.forEach( function ( opt ) {
					var o = document.createElement( 'option' );
					o.value       = opt;
					o.textContent = opt;
					sel.appendChild( o );
				} );

				// Style to match vfb inputs
				sel.style.height      = '52px';
				sel.style.width       = '100%';
				sel.style.padding     = '0 16px';
				sel.style.border      = '1px solid #d1d5db';
				sel.style.borderRadius = '8px';
				sel.style.background  = '#fff';
				sel.style.fontFamily  = 'Inter,sans-serif';
				sel.style.fontSize    = '14px';
				sel.style.color       = '#9ca3af';
				sel.style.cursor      = 'pointer';
				sel.style.outline     = 'none';
				sel.style.boxSizing   = 'border-box';
				sel.style.appearance  = 'none';

				// Background arrow
				sel.style.backgroundImage    = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23808080' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E\")";
				sel.style.backgroundRepeat   = 'no-repeat';
				sel.style.backgroundPosition = 'right 16px center';
				sel.style.paddingRight       = '44px';

				sel.addEventListener( 'change', function () {
					sel.style.color = sel.value ? '#1d2026' : '#9ca3af';
					// Sync CF7 required validation
					sel.classList.remove( 'wpcf7-not-valid' );
					var errTip = field.querySelector( '.wpcf7-not-valid-tip' );
					if ( errTip ) errTip.remove();
				} );

				wrap.replaceChild( sel, input );
			} );
		}() );

		/* ── Phone Number: allow only digits, max 10 ─────────────────────── */
		( function () {
			var phoneInput = cf7Wrap
				? qs( 'input[name="your-mobile"], input[type="tel"]', cf7Wrap )
				: null;
			if ( ! phoneInput ) { return; }

			phoneInput.setAttribute( 'maxlength', '10' );
			phoneInput.setAttribute( 'inputmode', 'numeric' );
			phoneInput.setAttribute( 'autocomplete', 'tel' );

			phoneInput.addEventListener( 'input', function () {
				var clean = phoneInput.value.replace( /\D/g, '' ).slice( 0, 10 );
				if ( phoneInput.value !== clean ) { phoneInput.value = clean; }
				setPhoneError( clean.length > 0 && clean.length < 10
					? '⚠️ Phone number must be exactly 10 digits.'
					: '' );
			} );

			phoneInput.addEventListener( 'keydown', function ( e ) {
				var allowed = [
					'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
					'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'
				];
				if ( allowed.indexOf( e.key ) !== -1 ) { return; }
				if ( e.ctrlKey || e.metaKey ) { return; }
				if ( ! /^\d$/.test( e.key ) ) { e.preventDefault(); }
			} );
		}() );

		function setPhoneError( msg ) {
			var phoneInput = cf7Wrap
				? qs( 'input[name="your-mobile"], input[type="tel"]', cf7Wrap )
				: null;
			if ( ! phoneInput ) { return; }
			var wrap = phoneInput.closest( '.wpcf7-form-control-wrap' ) || phoneInput.closest( '.vfb-field' ) || phoneInput.parentNode;
			var err  = wrap ? wrap.querySelector( '.vfb-phone-error' ) : null;
			if ( msg ) {
				phoneInput.style.borderColor = '#ef4444';
				if ( ! err && wrap ) {
					err = document.createElement( 'p' );
					err.className = 'vfb-phone-error';
					err.style.cssText = 'color:#ef4444;font-size:12px;margin:4px 0 0;font-family:Inter,sans-serif;font-weight:500;';
					wrap.appendChild( err );
				}
				if ( err ) { err.textContent = msg; }
			} else {
				phoneInput.style.borderColor = '';
				if ( err ) { err.textContent = ''; }
			}
		}

		/* ── Helper: show/clear an inline error for a date field ── */
		function setDateError( input, msg ) {
			var wrap = input ? input.closest( '.vfb-field' ) : null;
			if ( ! wrap ) { return; }
			var err = wrap.querySelector( '.vfb-date-error' );
			if ( msg ) {
				input.style.borderColor = '#ef4444';
				if ( ! err ) {
					err = document.createElement( 'p' );
					err.className = 'vfb-date-error';
					err.style.cssText = 'color:#ef4444;font-size:12px;margin:4px 0 0;font-family:Inter,sans-serif;font-weight:500;';
					wrap.appendChild( err );
				}
				err.textContent = msg;
			} else {
				if ( input ) input.style.borderColor = '';
				if ( err )   err.textContent = '';
			}
		}

		/* ── Custom "Register Me / Submit Now" button → native CF7 submit ── */
		if ( submitBtn ) {
			submitBtn.addEventListener( 'click', function () {
				updateCF7Fields();
				syncDates();

				var hasError = false;

				/* ── Validate: at least one Interest card must be selected ── */
				if ( cardsGrid ) {
					var interestErr = qs( '.vfb-interests-error', section );
					if ( selectedIds.length === 0 ) {
						if ( ! interestErr ) {
							interestErr = document.createElement( 'p' );
							interestErr.className = 'vfb-interests-error';
							cardsGrid.parentNode.insertBefore( interestErr, cardsGrid.nextSibling );
						}
						interestErr.textContent = '⚠️ Please select at least one Area of Interest.';
						cardsGrid.classList.add( 'vfb-invalid' );
						setTimeout( function () { cardsGrid.classList.remove( 'vfb-invalid' ); }, 500 );
						hasError = true;
					} else {
						if ( interestErr ) interestErr.textContent = '';
						cardsGrid.classList.remove( 'vfb-invalid' );
					}
				}

				/* ── Validate: Prefer To Work From card must be selected ── */
				if ( workFromGrid ) {
					syncWorkFrom();
					if ( ! selectedWorkFrom ) {
						showWorkFromError( '⚠️ Please select a "Prefer To Work From" option.' );
						hasError = true;
					} else {
						showWorkFromError( '' );
					}
				}

				/* ── Validate: Internship dates are required when section is visible ── */
				var datesSection = qs( '.vfb-dates-section', section );
				if ( datesSection ) {
					if ( startDateInput && ! startDateInput.value ) {
						setDateError( startDateInput, '⚠️ Please select a Starting Date.' );
						hasError = true;
					} else {
						setDateError( startDateInput, '' );
					}
					if ( endDateInput && ! endDateInput.value ) {
						setDateError( endDateInput, '⚠️ Please select an End Date.' );
						hasError = true;
					} else {
						setDateError( endDateInput, '' );
					}
				}

				/* ── Validate: Phone number must be exactly 10 digits ── */
				var phoneInput = cf7Wrap
					? qs( 'input[name="your-mobile"], input[type="tel"]', cf7Wrap )
					: null;
				if ( phoneInput ) {
					var phoneVal = phoneInput.value.replace( /\D/g, '' );
					if ( phoneVal.length !== 10 ) {
						setPhoneError( '⚠️ Please enter a valid 10-digit phone number.' );
						hasError = true;
					} else {
						setPhoneError( '' );
					}
				}

				/* ── Scroll to first error ── */
				if ( hasError ) {
					var firstErr = qs(
						'.vfb-interests-error:not(:empty), .vfb-workfrom-error:not(:empty), .vfb-date-error:not(:empty), .vfb-phone-error:not(:empty)',
						section
					);
					if ( firstErr ) { firstErr.scrollIntoView( { behavior: 'smooth', block: 'center' } ); }
					return;
				}

				if ( ! cf7Wrap ) { return; }

				var cf7Form = qs( 'form.wpcf7-form', cf7Wrap );
				if ( ! cf7Form ) { return; }

				submitBtn.disabled = true;
				submitBtn.classList.add( 'vfb-loading' );
				submitBtn.textContent = 'Sending…';

				// Click the form's native submit button — CF7's own JS handles
				// AJAX + email reliably (same pattern as donate-form).
				var cf7SubmitBtn = qs( '[type="submit"]', cf7Form );
				if ( cf7SubmitBtn ) {
					cf7SubmitBtn.click();
				} else {
					cf7Form.dispatchEvent( new Event( 'submit', { bubbles: true, cancelable: true } ) );
				}
			} );
		}

		/* ── CF7 event listeners ─────────────────────────────────────────── */
		if ( cf7Wrap ) {

			cf7Wrap.addEventListener( 'wpcf7mailsent', function () {

				// Build filter slugs from all selected interests + work-from
				var filterSlugs = selectedIds.filter( function ( id ) { return id !== 'other'; } );
				if ( selectedWorkFrom ) { filterSlugs.push( selectedWorkFrom ); }

				if ( redirectUrl ) {
					var sep = redirectUrl.indexOf( '?' ) === -1 ? '?' : '&';
					var dest = redirectUrl;
					if ( filterSlugs.length > 0 ) {
						dest += sep + 'filter=' + encodeURIComponent( filterSlugs.join( ',' ) );
					}
					window.location.href = dest;
					return;
				}

				// No redirect — reset everything, let CF7 show success message
				selectedIds = [];

				qsa( '.vfb-card', cardsGrid ).forEach( function ( c ) {
					c.classList.remove( 'vfb-card-active' );
					c.setAttribute( 'aria-checked', 'false' );
				} );

				// Reset work-from cards
				selectedWorkFrom = '';
				if ( workFromGrid ) {
					qsa( '.vfb-workfrom-card', workFromGrid ).forEach( function ( c ) {
						c.classList.remove( 'vfb-workfrom-active' );
						c.setAttribute( 'aria-checked', 'false' );
					} );
				}
				showWorkFromError( '' );

				syncOtherField();
				restoreBtn();
			} );

			// Validation error / spam / mail failed
			cf7Wrap.addEventListener( 'wpcf7invalid',    restoreBtn );
			cf7Wrap.addEventListener( 'wpcf7spam',       restoreBtn );
			cf7Wrap.addEventListener( 'wpcf7mailfailed', restoreBtn );
		}

		function restoreBtn() {
			if ( submitBtn ) {
				submitBtn.disabled = false;
				submitBtn.classList.remove( 'vfb-loading' );
				// Restore original text from the DOM (set by render.php)
				submitBtn.textContent = submitBtn.dataset.label || submitBtn.textContent || 'Submit';
			}
		}

	} );
} )();
